// extracted by mini-css-extract-plugin
export default {"bottomWrapDetails":"bottombar_bottomWrapDetails__f0pZC","bottomWrap":"bottombar_bottomWrap__hXraV","menuItem":"bottombar_menuItem__suOn6","avatar":"bottombar_avatar__ADssY"};